'use client';

import { PropsWithChildren } from 'react';

import { Card } from './Card';
import { BgPosition, CardVariant } from '../types';

import { classNames } from '@/shared/lib/classNames/classNames';

interface CardWithGradientProps {
  rounded?: string;
  mobilePlacement: BgPosition;
  pcPlacement: BgPosition;
  className?: string;
  variant?: CardVariant;
}

export const CardWithGradient = ({
  children,
  rounded = '20',
  mobilePlacement,
  pcPlacement,
  className,
  variant,
}: PropsWithChildren<CardWithGradientProps>) => {
  return (
    <Card rounded={rounded} className={className} variant={variant}>
      <div
        className={classNames({
          cls: 'relative h-full w-full overflow-hidden',
          mods: { [`rounded-[${rounded}px]`]: true },
        })}
      >
        {children}
        {/** Градиент для мобильных устройств */}
        <div
          style={{
            background:
              'radial-gradient(53.23% 50.88% at 50% 50%, rgba(59, 182, 67, 0.22) 0%, rgba(59, 182, 67, 0.00) 100%)',
          }}
          className={classNames({
            cls: 'pointer-events-none absolute size-full rounded-[100%] lg:hidden',
            mods: {
              [BG_POSITIONS[mobilePlacement]]: true,
            },
          })}
        />

        {/** Градиент для браузеров */}
        <div
          style={{
            background:
              'radial-gradient(53.23% 50.88% at 50% 50%, rgba(59, 182, 67, 0.22) 0%, rgba(59, 182, 67, 0.00) 100%)',
          }}
          className={classNames({
            cls: 'pointer-events-none absolute size-full rounded-[100%] max-lg:hidden',
            mods: {
              [BG_POSITIONS[pcPlacement]]: true,
            },
          })}
        />
      </div>
    </Card>
  );
};

export const BG_POSITIONS: Record<BgPosition, string> = {
  'top-left': 'top-[-40%] left-[-30%] -rotate-11',
  'top-right': 'top-[-40%] right-[-30%] rotate-15',
  'bottom-left': 'bottom-[-40%] left-[-30%] rotate-15',
  'bottom-right': 'bottom-[-40%] right-[-30%] rotate-15',
};
